module.exports = __webpack_public_path__ + "img/human.a35fd765.png";